import axios from 'axios';

const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000',
  // Add other configuration options as needed
};

// Configure axios defaults
axios.defaults.withCredentials = true;
axios.defaults.baseURL = config.apiBaseUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Add request interceptor
axios.interceptors.request.use(
  config => {
    // Get session ID from cookie
    const sessionId = document.cookie
      .split('; ')
      .find(row => row.startsWith('sessionId='))
      ?.split('=')[1];

    if (sessionId) {
      config.headers['X-Session-ID'] = sessionId;
    }

    // Ensure credentials are included
    config.withCredentials = true;

    // Request logging handled by logging middleware
    return config;
  },
  error => {
    // Request error logged by logging middleware
    return Promise.reject(error);
  }
);

// Add response interceptor
axios.interceptors.response.use(
  response => {
    // Response logging handled by logging middleware
    return response;
  },
  error => {
    // Response error logged by logging middleware
    
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default config; 